import { UserRole } from "../../store/store.model";
export let BusinessType;

(function (BusinessType) {
  BusinessType["Accounting"] = "accounting";
  BusinessType["Bookkeeping"] = "bookkeeping";
  BusinessType["TaxRepresentation"] = "tax";
  BusinessType["TaxPreparation"] = "tax_preparation";
  BusinessType["TaxResolution"] = "tax_resolution";
  BusinessType["Marketing"] = "marketing";
  BusinessType["Other"] = "other";
})(BusinessType || (BusinessType = {}));

export let Step;

(function (Step) {
  Step["First"] = "first";
  Step["Second"] = "second";
  Step["QBO"] = "qbo";
  Step["QBOSetup"] = "qboSetup";
  Step["Saving"] = "Saving";
})(Step || (Step = {}));

export let ErrorType;

(function (ErrorType) {
  ErrorType["General"] = "general";
  ErrorType["Stripe"] = "stripe";
})(ErrorType || (ErrorType = {}));

export function isValidWorkspace(workspace) {
  return workspace.features.accountsPayable && [UserRole.Owner, UserRole.Admin, UserRole.Member].includes(workspace.role) || workspace.features.accountsReceivable && workspace.setupCompleted;
}